export enum TimeUnits {
  Hour = 'hour',
  FourHours = '4_hours',
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}
export interface Range {
  min?: number;
  max?: number;
}

export interface Paginated<T> {
  page: T[];
  totalPages: number;
}

export interface Filters {
  startDate: string;
  endDate: string;
  aggregationUnit: TimeUnits;
  determinationFilters?: string[];
  eligibleUnitRange?: Range;
  payoutAmountRange?: Range;
  scoreRange?: Range;
  acceptedDeductionCodes?: string[];
}

export interface DeterminationFilters {
  startDate?: string;
  endDate?: string;
  eligibleUnitRangeMin?: number;
  eligibleUnitRangeMax?: number;
  payoutAmountRangeMin?: number;
  payoutAmountRangeMax?: number;
  scoreRangeMin?: number;
  scoreRangeMax?: number;
  acceptedDeductionCodes?: string[];
  determinationFilters?: string[];
}

export enum UserRole {
  Owner = 'owner',
  Admin = 'admin',
  Reviewer = 'reviewer',
  Viewer = 'viewer',
}

export enum ApprovalStatus {
  Approved = 'approved',
  Pending = 'pending',
  Denied = 'denied',
}

export enum TimeRange {
  Today = 'today',
  LastWeek = 'last_7_days',
  LastMonth = 'last_30_days',
}
